import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedAdjusterAttachedImagesQueryParamsType,
  GetDamagedAdjusterAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterAttachedImages/getDamagedAdjusterAttachedImagesQuery.type';
import { AdditionalApiUrlCreator } from '@/modules/adjusterReportModules/IncidentParticipants/utils/AdditionalApiUrlCreator';

export const getAdjusterAttachedImagesFunction = ({
  id,
  damaged_id,
  type,
  fileType,
}: GetDamagedAdjusterAttachedImagesQueryParamsType): Promise<GetDamagedAdjusterAttachedImagesQueryResponseType> => {
  const url = AdditionalApiUrlCreator({
    id,
    TabType: type,
    userType: fileType,
  });

  return fetchApi.get(url, {
    params: fileType === 'damaged' ? { damaged_id: damaged_id } : undefined,
  });
};
